import { render, staticRenderFns } from "./dropdown_demo.vue?vue&type=template&id=ff46c04e&scoped=true&"
import script from "./dropdown_demo.vue?vue&type=script&lang=ts&"
export * from "./dropdown_demo.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown_demo.vue?vue&type=style&index=0&id=ff46c04e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff46c04e",
  null
  
)

export default component.exports